module.exports = __webpack_public_path__ + "media/images/flags/64/Angola-e6c65b03ebf898e59b03f634317111a5.png";